import { PawPrint, Bell, Pencil, BarChart3, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

const benefits = [
  {
    icon: Bell,
    title: "Aktualizuj potrzeby",
    desc: "i oznaczaj jako pilne",
    highlight: true,
  },
  {
    icon: Pencil,
    title: "Edytuj dane organizacji",
    desc: "kontakt, opis, godziny",
    highlight: false,
  },
  {
    icon: BarChart3,
    title: "Sprawdzaj statystyki",
    desc: "wyświetleń profilu",
    highlight: false,
  },
];

/**
 * Post 1080x1080: Korzyści z panelu organizacji
 */
export const InstagramPostOwnerPanelBenefits = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 70px",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          background: "#2D5A3D",
          padding: "10px 22px",
          borderRadius: "999px",
          marginBottom: "20px",
        }}
      >
        <Sparkles style={{ width: "20px", height: "20px", color: "#FFFFFF" }} />
        <span
          style={{
            fontSize: "20px",
            fontWeight: 800,
            color: "#FFFFFF",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          Panel organizacji
        </span>
      </div>

      <h1
        style={{
          fontSize: "68px",
          fontWeight: 900,
          color: "#2D5A3D",
          margin: "0 0 14px",
          textAlign: "center",
          lineHeight: 1.05,
        }}
      >
        Co dostajesz<br />w panelu?
      </h1>

      <p
        style={{
          fontSize: "24px",
          fontWeight: 600,
          color: "#5A8A70",
          margin: "0 0 36px",
          textAlign: "center",
          maxWidth: "780px",
          lineHeight: 1.3,
        }}
      >
        Łatwo, bezpłatnie i bez technicznej wiedzy 💚
      </p>

      <div
        style={{
          width: "100%",
          maxWidth: "880px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {benefits.map(({ icon: Icon, title, desc, highlight }) => (
          <div
            key={title}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "22px",
              background: highlight ? "#FFF7ED" : "#FFFFFF",
              padding: "24px 28px",
              borderRadius: "22px",
              border: highlight ? "2px solid #FDBA74" : "1px solid rgba(45,90,61,0.12)",
              boxShadow: "0 8px 24px rgba(15,42,28,0.08)",
            }}
          >
            <div
              style={{
                background: highlight ? "#F59E0B" : "#2D5A3D",
                borderRadius: "18px",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon style={{ width: "32px", height: "32px", color: "#FFFFFF" }} strokeWidth={2.5} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 800,
                  color: highlight ? "#D97706" : "#2D5A3D",
                  margin: 0,
                  lineHeight: 1.2,
                }}
              >
                {title}
              </h3>
              <p
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  color: highlight ? "#B45309" : "#5A8A70",
                  margin: 0,
                  lineHeight: 1.25,
                }}
              >
                {desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: "36px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "12px",
            width: "44px",
            height: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PawPrint style={{ width: "24px", height: "24px", color: "#FFFFFF" }} />
        </div>
        <span style={{ fontSize: "26px", fontWeight: 800, color: "#2D5A3D" }}>
          gdzieschronisko.pl/panel
        </span>
      </div>
    </GraphicBackground>
  );
};
